<div class="ppl-mt20 p-2">
  @if(staffView) {
  <div class="custom-row pr-3">
    <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
      (click)="onCancel()"></ppl-button>
  </div>
  }
  <div class="warning-message mb-4 alert alert-warning pt-1 pb-3">
    <span class="fs-6"><strong>Warning: </strong>Manually entering time or editing a clock in /clock out time is not EVV
      compliant. Please
      remember to use the Time4Care app to clock in /clock out in real-time.</span>
  </div>

  <form nz-form nz-row [formGroup]="addTimesheetForm" class="ppl-p0 mt-2">
    @if(entryPage === 'timesheets') {
    <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="lastName" class="ppl-form-label">Provider PPL ID<span>*</span>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
          <input nz-input formControlName="providerPplId" id="providerPplId" />
          @if (pplIdError) {
              <span class="pl-1 error-message">Please enter a PPL ID to search.</span>
          }
        </nz-form-control>
        <div class="ms-2">
          <ppl-button label="Get Participants" (click)="getConsumersAndPayPeriod()" [customClass]="'primary-button'"
            [iconPosition]="'left'"></ppl-button>
        </div>
      </nz-row>
      @if (pplIdError) {
      <span class="pl-1 error-message">Please enter a PPL ID to search.</span>
      }

    </nz-form-item>

    }

    @if(showFormFields) {

    @if(entryType === 'timeEntry' || action === 'edit'){
    <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="consumer" class="ppl-form-label">
          Participant
          <span>*</span>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
          <nz-select formControlName="consumer" class="ppl-select" nzId="consumer" nzPlaceHolder="Select Participant"
            nzShowSearch (ngModelChange)="enableTimesheetForm($event)">
            @for(opt of consumers; track $index){
            <nz-option [nzLabel]="opt.consumerFullName" [nzValue]="opt.consumerId"></nz-option>
            }
          </nz-select>

          @if(!consumers || consumers.length == 0){
          <span class="pl-1 error-message">You don't have any active participants.</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="6" [nzXs]="24" class="ppl-form-label">
          Service Period
          <span>*</span>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
          <nz-select class="ppl-select" id="period" formControlName="period" nzPlaceHolder="Service Period" nzShowSearch
            (ngModelChange)="enableTimesheetForm()">
            @for(opt of payPeriod; track $index){
            <nz-option [nzLabel]="opt.payPeriod" [nzValue]="opt.payrollId"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }
    @if(showEntries && timesheetEntries?.controls.length > 0) {
      <!-- @if(entryType === 'timeEntry'){ -->
    <div formArrayName="timesheetEntries" style="width: 100%;">
      <!-- Desktop / >=992px: original table layout -->
      <div *ngIf="!(isHandsetView$ | async)">
        <table class="timesheet-table">
          <thead>
            <tr>
              <th style="background-color: #a8e4e14d; width: 3%;"></th>
              <th style="background-color: #a8e4e14d; width: 8%;">Service Date</th>
              <th style="background-color: #a8e4e14d; width: 15%;">Service Code *</th>
              <th style="background-color: #a8e4e14d; width: 15%;">Service Description *</th>
              <th style="background-color: #a8e4e14d; width: 11%;">Clock In<br>Service Location *</th>
              <th style="background-color: #a8e4e14d; width: 8%;">Time In *</th>
              <th style="background-color: #a8e4e14d; width: 11%;">Clock Out<br>Service Location *</th>
              <th style="background-color: #a8e4e14d; width: 8%;">Time Out *</th>
              <th style="background-color: #a8e4e14d; width: 6%;">Total Time</th>
              <th style="display: none;">Units (15 Mins increment)</th>
              @if(entryType === 'timeEntry' || action === 'edit'){
              <th style="background-color: #a8e4e14d; width: 15%;">Manual Entry Reason *</th>
              @if(action === 'edit'){
              <th style="background-color: #a8e4e14d; width: 7%;">Status</th>
              }
              @if(action === 'edit'){
              <th style="background-color: #a8e4e14d; width: 7%;">Processing Status</th>
              }
              @if(entryType === 'timeEntry' || action === 'edit'){
              <th style="background-color: #a8e4e14d; width: 13%;">Actions</th>
              }
              }
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of timesheetEntries.controls; let i = index" [formGroupName]="i">
              <td style="padding-left: 10px;">
                <label nz-checkbox formControlName="selected"></label>
              </td>
              <td>
                <span [innerHTML]="entry.get('serviceDate')?.value | dateWithDayOfWeek"></span>
              </td>
              @if(entryType === 'timeEntry' || action==='edit'){
              <td>
                @if(entry.get('displayOnly')?.value) {
                <span>{{ entry.get('serviceCodeDisplay')?.value }}</span>
                } @else if(entryType === 'timeEntry') {
                <nz-select class="ppl-select" formControlName="service" nzPlaceHolder="Select Service" nzShowSearch
                  nzAllowClear (ngModelChange)="checkService($event, i); timesheetEntries.at(i).get('serviceDescription')?.reset()"
                  [ngClass]="{ 'error-border': isFieldEmpty('service', i) }">
                  <nz-option *ngFor="let opt of getFilteredServiceCodesForDate(entry)"
                    [nzLabel]="opt.serviceCodeDetail" [nzValue]="opt"></nz-option>
                </nz-select>
                }
              </td>
              }
              @else {
              <td>
                <nz-select class="ppl-select" formControlName="service" nzPlaceHolder="Select Service" nzShowSearch
                  nzAllowClear (ngModelChange)="checkService($event, i)"
                  [ngClass]="{ 'error-border': isFieldEmpty('service', i) }">
                  <nz-option *ngFor="let opt of serviceCodesTO" [nzLabel]="opt.description" [nzValue]="opt"></nz-option>
                </nz-select>
              </td>
              }
              <td>
                @if(entry.get('displayOnly')?.value) {
                <span>{{ entry.get('serviceDescriptionDisplay')?.value }}</span>
                } @else {
                <nz-select class="ppl-select" formControlName="serviceDescription" nzPlaceHolder="Service Description" nzShowSearch
                  nzAllowClear
                  [ngClass]="{ 'error-border': isFieldEmpty('serviceDescription', i) }">
                  <nz-option
                    *ngFor="let opt of getServiceDescriptionsBasedOnServiceDate((timesheetEntries.at(i).get('serviceDate')?.value), (timesheetEntries.at(i).get('service')?.value))"
                    [nzLabel]="opt.desc" [nzValue]="opt.ids"></nz-option>
                </nz-select>
                }
              </td>
              <td>
                @if(entry.get('isOvertimeEntry')?.value) {
                <span>-</span>
                } @else {
                <nz-select class="ppl-select" formControlName="clockInLocation" nzPlaceHolder="Clock In Service Location" nzShowSearch
                  nzAllowClear (ngModelChange)="checkService($event, i)"
                  [ngClass]="{ 'error-border': isFieldEmpty('clockInLocation', i) }">
                  <nz-option *ngFor="let opt of serviceLocations" [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueName"></nz-option>
                </nz-select>
                }
              </td>
              <td>
                @if(entry.get('isOvertimeEntry')?.value) {
                <span>-</span>
                } @else {
                <p-datepicker formControlName="serviceTimeIn" [timeOnly]="true" [hourFormat]="'12'" placeholder="HH:MM AM/PM"
                  [ngClass]="{ 'error-border': isFieldEmpty('serviceTimeIn', i) || isBilledUnitsNegative(i) }">
                </p-datepicker>
                <div *ngIf="fieldErrors[i]?.['timeInEqualTimeOut']">
                  <p class="error-message">{{timeInTimeOutEqualMessage}}</p>
                </div>
                }
              </td>
              <td>
                @if(entry.get('isOvertimeEntry')?.value) {
                <span>-</span>
                } @else {
                <nz-select class="ppl-select" formControlName="clockOutLocation" nzPlaceHolder="Clock Out Service Location" nzShowSearch
                  nzAllowClear (ngModelChange)="checkService($event, i)"
                  [ngClass]="{ 'error-border': isFieldEmpty('clockOutLocation', i) }">
                  <nz-option *ngFor="let opt of serviceLocations" [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueName"></nz-option>
                </nz-select>
                }
              </td>
              <td>
                @if(entry.get('isOvertimeEntry')?.value) {
                <span>-</span>
                } @else {
                <p-datepicker formControlName="serviceTimeOut" [timeOnly]="true" [hourFormat]="'12'" placeholder="HH:MM AM/PM"
                  [ngClass]="{ 'error-border': isFieldEmpty('serviceTimeOut', i) || isBilledUnitsNegative(i) || timesheetEntries.at(i).get('serviceTimeOut')?.errors?.['invalidTimeRange']}">
                </p-datepicker>
                <div *ngIf="(fieldErrors[i]?.['timeInAfterTimeOut'] || timesheetEntries.at(i).get('serviceTimeOut')?.errors?.['invalidTimeRange'])">
                  <p class="error-message">{{timeOutLessThanTimeInMessage}}</p>
                </div>
                <div *ngIf="fieldErrors[i]?.['timeInAfterTimeOutOverNightShift']">
                  <p class="error-message">{{timeOutOverNightShiftMessage}}</p>
                </div>
                }
              </td>
              <td>
                @if(entry.get('displayOnly')?.value) {
                <span style="font-size: 13px;font-weight: bold;">{{ entry.get('totalTimeOnDisplay')?.value }}</span>
                } @else {
                <input nz-input formControlName="totalTime" id="totalTime" style="font-size: 13px;font-weight: bold;" />
                }
              </td>
              <td style="display: none;">
                <input nz-input formControlName="billedUnits" id="billedUnits" />
              </td>
              @if(entryType === 'timeEntry' || action === 'edit'){
              <td>
                <nz-select class="ppl-select" formControlName="manualReasonLkp" nzPlaceHolder="Select Reason" nzShowSearch
                  nzAllowClear [ngClass]="{ 'error-border': isFieldEmpty('manualReasonLkp', i) }">
                  @for(opt of getReasonOptionsForEntry(entry); track $index){
                  <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
                  }
                </nz-select>
              </td>
              @if(action === 'edit'){
              <td>
                <p>{{ timesheetEntries.get([i, 'businessStatusLkp'])?.value || null }}</p>
              </td>
              }
              @if(action === 'edit'){
              <td>
                @if(timesheetEntries.get([i, 'applicationStatusLkp'])?.value == 'Pended' || timesheetEntries.get([i,
                'applicationStatusLkp'])?.value == 'Denied') {
                <p class="hyperlink" (click)="rowClickedTs(timesheetEntries.get([i,
                  'applicationStatusLkp'])?.value || null, timesheetEntries.get([i,
                  'timeSheetDetailId'])?.value || null)">{{ timesheetEntries.get([i,
                  'applicationStatusLkp'])?.value || null }}</p>
                } @else {
                <p>{{ timesheetEntries.get([i, 'applicationStatusLkp'])?.value || null }}</p>
                }
              </td>
              }
              @if(action === 'edit'){
              @if (isReadOnly) {
              <td></td>
              } @else {
              <td>
                <div class="custom-btn-row">
                  @if(timesheetEntries.get([i, 'businessStatusLkp'])?.value !== 'Paid' || timesheetEntries.get([i,
                  'businessStatusLkp'])?.value !== 'Good to Pay') {
                  <div nz-tooltip [nzTooltipTitle]="'Add'" class="tooltip-container">
                    <ppl-button label="" *ngIf="!entry.get('isNewRow')?.value" [disabled]="isAddDisabled(entry)"
                      (click)="addTimeSlot(i)" icon="fa fa-plus" [customClass]="'ghost-button'"
                      [iconPosition]="'left'"></ppl-button>
                  </div>
                  <div nz-tooltip [nzTooltipTitle]="'Duplicate'" class="tooltip-container">
                    <ppl-button label="" *ngIf="!entry.get('isNewRow')?.value" [disabled]="isAddDisabled(entry)"
                      (click)="duplicateRow(i)" icon="fa fa-clone" [customClass]="'ghost-button'"
                      [iconPosition]="'left'"></ppl-button>
                  </div>
                  <div nz-tooltip [nzTooltipTitle]="'Delete'" class="tooltip-container">
                    <ppl-button label="" *ngIf="entry.get('isNewRow')?.value" (click)="deleteRow(i)" icon="pi pi-trash"
                      [customClass]="'ghost-button'" [iconPosition]="'left'"></ppl-button>
                  </div>
                  }
                  @if(timesheetEntries.get([i, 'businessStatusLkp'])?.value === 'Saved'){
                  <div nz-tooltip [nzTooltipTitle]="'Delete'" class="tooltip-container">
                    <ppl-button label="" (click)="openConfirmationPopup(i)" icon="pi pi-trash"
                      [customClass]="'ghost-button'" [iconPosition]="'left'"></ppl-button>
                  </div>
                  }
                </div>
              </td>
              }
            }
              @if(entryType === 'timeEntry' && action !== 'edit' && !isReadOnly) {
              <td>
                <div class="custom-btn-row">
                  <div nz-tooltip [nzTooltipTitle]="'Add'" class="tooltip-container mr-2">
                    <ppl-button label="" *ngIf="!entry.get('isNewRow')?.value" [disabled]="isAddDisabled(entry)"
                      (click)="addTimeSlot(i)" icon="fa fa-plus" [customClass]="'ghost-button'"
                      [iconPosition]="'left'"></ppl-button>
                  </div>
                  <div nz-tooltip [nzTooltipTitle]="'Duplicate'" class="tooltip-container">
                    <ppl-button label="" *ngIf="!entry.get('isNewRow')?.value" [disabled]="isAddDisabled(entry)"
                      (click)="duplicateRow(i)" icon="fa fa-clone" [customClass]="'ghost-button'"
                      [iconPosition]="'left'"></ppl-button>
                  </div>
                  <div nz-tooltip [nzTooltipTitle]="'Delete'" class="tooltip-container mr-2">
                    <ppl-button label="" *ngIf="entry.get('isNewRow')?.value" (click)="deleteRow(i)" icon="pi pi-trash"
                      [customClass]="'ghost-button'" [iconPosition]="'left'"></ppl-button>
                  </div>
                </div>
              </td>
              }
            }
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Mobile / <992px: collapsible stacked rows -->
      <div *ngIf="isHandsetView$ | async">
        <div *ngFor="let entry of timesheetEntries.controls; let i = index" [formGroupName]="i" class="mobile-timesheet-card mb-2" style="width:100%; box-sizing:border-box;">
          <details>
        <summary class="mobile-summary">
          <div class="d-flex justify-content-between align-items-center">
          <div>
            <div class="fw-bold" [innerHTML]="entry.get('serviceDate')?.value | dateWithDayOfWeek"></div>
            <div class="text-muted small">
          <span *ngIf="entry.get('service')?.value">{{ (entry.get('service')?.value?.serviceCodeDetail || entry.get('service')?.value?.code) }}</span>
          <span *ngIf="entry.get('service')?.value"> • </span>
          <span *ngIf="entry.get('totalTime')?.value">Total: {{ entry.get('totalTime')?.value }}</span>
            </div>
          </div>
          <div class="mobile-actions d-flex">
            <!-- keep action icons compact for mobile -->
            <ppl-button label="" *ngIf="!entry.get('isNewRow')?.value && !(isReadOnly)" [disabled]="isAddDisabled(entry)"
          (click)="addTimeSlot(i)" icon="fa fa-plus" [customClass]="'ghost-button'"></ppl-button>
            <ppl-button label="" *ngIf="!entry.get('isNewRow')?.value && !(isReadOnly)" [disabled]="isAddDisabled(entry)"
          (click)="duplicateRow(i)" icon="fa fa-clone" [customClass]="'ghost-button'"></ppl-button>
            <ppl-button label="" *ngIf="entry.get('isNewRow')?.value && !(isReadOnly)" (click)="deleteRow(i)" icon="pi pi-trash"
          [customClass]="'ghost-button'"></ppl-button>
          </div>
          </div>

        </summary>


        <div class="mobile-card-body mt-2">
          <!-- Service Code -->
          <div class="mb-2">
            <label class="fw-semibold">Service Code *</label>
            @if(entry.get('displayOnly')?.value) {
            <div>{{ entry.get('serviceCodeDisplay')?.value }}</div>
            } @else if(entryType === 'timeEntry' || action==='edit'){
            <nz-select class="ppl-select" formControlName="service" nzPlaceHolder="Select Service" nzShowSearch
          nzAllowClear (ngModelChange)="checkService($event, i); timesheetEntries.at(i).get('serviceDescription')?.reset()"
          [ngClass]="{ 'error-border': isFieldEmpty('service', i) }">
          <nz-option *ngFor="let opt of getFilteredServiceCodesForDate(entry)"
            [nzLabel]="opt.serviceCodeDetail" [nzValue]="opt"></nz-option>
            </nz-select>
            } @else {
            <nz-select class="ppl-select" formControlName="service" nzPlaceHolder="Select Service" nzShowSearch
          nzAllowClear (ngModelChange)="checkService($event, i)"
          [ngClass]="{ 'error-border': isFieldEmpty('service', i) }">
          <nz-option *ngFor="let opt of serviceCodesTO" [nzLabel]="opt.description" [nzValue]="opt"></nz-option>
            </nz-select>
            }
          </div>

          <!-- Service Description -->
          <div class="mb-2">
            <label class="fw-semibold">Service Description *</label>
            @if(entry.get('displayOnly')?.value) {
            <div>{{ entry.get('serviceDescriptionDisplay')?.value }}</div>
            } @else {
            <nz-select class="ppl-select" formControlName="serviceDescription" nzPlaceHolder="Service Description" nzShowSearch
          nzAllowClear [ngClass]="{ 'error-border': isFieldEmpty('serviceDescription', i) }">
           <nz-option
              *ngFor="let opt of getServiceDescriptionsBasedOnServiceDate((timesheetEntries.at(i).get('serviceDate')?.value), (timesheetEntries.at(i).get('service')?.value))"
              [nzLabel]="opt.desc" [nzValue]="opt.ids"></nz-option>
            </nz-select>
            }
          </div>

          <!-- Clock In -->
          <div class="mb-2">
            <label class="fw-semibold">Clock In Location *</label>
            @if(entry.get('isOvertimeEntry')?.value) {
            <span>-</span>
            } @else {
            <nz-select class="ppl-select" formControlName="clockInLocation" nzPlaceHolder="Clock In Service Location" nzShowSearch
          nzAllowClear (ngModelChange)="checkService($event, i)"
          [ngClass]="{ 'error-border': isFieldEmpty('clockInLocation', i) }">
          <nz-option *ngFor="let opt of serviceLocations" [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueName"></nz-option>
            </nz-select>
            }
          </div>
          <div class="mb-2">
            <label class="fw-semibold">Time In *</label>
            @if(entry.get('isOvertimeEntry')?.value) {
            <span>-</span>
            } @else {
            <p-datepicker formControlName="serviceTimeIn" [timeOnly]="true" [hourFormat]="'12'" placeholder="HH:MM AM/PM"
          [ngClass]="{ 'error-border': isFieldEmpty('serviceTimeIn', i) || isBilledUnitsNegative(i) }">
            </p-datepicker>
            <div *ngIf="fieldErrors[i]?.['timeInEqualTimeOut']">
          <p class="error-message">{{timeInTimeOutEqualMessage}}</p>
            </div>
            }
          </div>

          <!-- Clock Out -->
          <div class="mb-2">
            <label class="fw-semibold">Clock Out Location *</label>
            @if(entry.get('isOvertimeEntry')?.value) {
            <span>-</span>
            } @else {
            <nz-select class="ppl-select" formControlName="clockOutLocation" nzPlaceHolder="Clock Out Service Location" nzShowSearch
          nzAllowClear (ngModelChange)="checkService($event, i)"
          [ngClass]="{ 'error-border': isFieldEmpty('clockOutLocation', i) }">
          <nz-option *ngFor="let opt of serviceLocations" [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueName"></nz-option>
            </nz-select>
            }
          </div>
          <div class="mb-2">
            <label class="fw-semibold">Time Out *</label>
            @if(entry.get('isOvertimeEntry')?.value) {
            <span>-</span>
            } @else {
            <p-datepicker formControlName="serviceTimeOut" [timeOnly]="true" [hourFormat]="'12'" placeholder="HH:MM AM/PM"
          [ngClass]="{ 'error-border': isFieldEmpty('serviceTimeOut', i) || isBilledUnitsNegative(i) || timesheetEntries.at(i).get('serviceTimeOut')?.errors?.['invalidTimeRange']}">
            </p-datepicker>
            <div *ngIf="(fieldErrors[i]?.['timeInAfterTimeOut'] || timesheetEntries.at(i).get('serviceTimeOut')?.errors?.['invalidTimeRange'])">
          <p class="error-message">{{timeOutLessThanTimeInMessage}}</p>
            </div>
            <div *ngIf="fieldErrors[i]?.['timeInAfterTimeOutOverNightShift']">
          <p class="error-message">{{timeOutOverNightShiftMessage}}</p>
            </div>
            }
          </div>

          <!-- Total, Units, Manual Reason -->
          <div class="mb-2">
            <label class="fw-semibold">Total Time</label>
            @if(entry.get('displayOnly')?.value) {
            <div style="font-size: 11px;">{{ entry.get('totalTimeOnDisplay')?.value }}</div>
            } @else {
            <input nz-input formControlName="totalTime" id="totalTime" style="font-size: 11px;" />
            }
          </div>

          <div class="mb-2" *ngIf="entryType === 'timeEntry' || action === 'edit'">
            <label class="fw-semibold">Manual Entry Reason *</label>
            <nz-select class="ppl-select" formControlName="manualReasonLkp" nzPlaceHolder="Select Reason" nzShowSearch
          nzAllowClear [ngClass]="{ 'error-border': isFieldEmpty('manualReasonLkp', i) }">
          @for(opt of getReasonOptionsForEntry(entry); track $index){
          <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
          }
            </nz-select>
          </div>

          <!-- Status / Processing Status for edit -->
          <div class="mb-2" *ngIf="action === 'edit'">
            <div><strong>Status:</strong> {{ timesheetEntries.get([i, 'businessStatusLkp'])?.value || '-' }}</div>
            <div>
          <strong>Processing Status:</strong>
          <span *ngIf="timesheetEntries.get([i, 'applicationStatusLkp'])?.value == 'Pended' || timesheetEntries.get([i, 'applicationStatusLkp'])?.value == 'Denied'">
            <span class="hyperlink" (click)="rowClickedTs(timesheetEntries.get([i, 'applicationStatusLkp'])?.value || null, timesheetEntries.get([i, 'timeSheetDetailId'])?.value || null)">
              {{ timesheetEntries.get([i, 'applicationStatusLkp'])?.value || '-' }}
            </span>
          </span>
          <span *ngIf="!(timesheetEntries.get([i, 'applicationStatusLkp'])?.value == 'Pended' || timesheetEntries.get([i, 'applicationStatusLkp'])?.value == 'Denied')">
            {{ timesheetEntries.get([i, 'applicationStatusLkp'])?.value || '-' }}
          </span>
            </div>
          </div>
        </div>
          </details>
        </div>
      </div>
    </div>

    <div class="custom-row">
      <label nz-checkbox formControlName="isAgreed" [ngClass]="{'error-class': isConsentRequired && !isAgreed}">
        By signing below, I certify that I have provided the services to the participant during the times described on this
        timesheet.
      </label>
    </div>
    @if((entryType === 'timeEntry' || action === 'edit') && !isReadOnly){
    <div class="custom-row" style="width: 100%;">
      @if( !isExternal && entryPage !== 'timesheets') {
      <ppl-button (click)="onMoveBack()" [styleString]="'margin-right: 8px;'" label="Move Back"
        icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
      }

      @if(entryPage !== 'timesheets') {
      <ppl-button [disabled]="isSaveDisabled" (click)="evaluateLongShiftHoursAndSave('save')" [styleString]="'margin-right: 8px;'"
        label="Save" icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
      }

      <ppl-button [disabled]="isSaveDisabled" (click)="evaluateLongShiftHoursAndSave('submit')"
        [label]="entryPage === 'timesheets' ? 'Submit' : 'Save & Submit'" icon="fa fa-check-circle"
        [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
    </div>
    }
    }
    @else {
    @if (customErrors && customErrors.length) {
    <div class="row">
      <div class="col-12 mb-3">
        <p>
          There is an issue preventing this shift from being entered. If you are unable to resolve the error in red,
          contact PPL customer service at 1-833-247-5346 for help.
        </p>
      </div>
      <div class="col-12">
        <div class="alert alert-danger">
          <strong>Error: </strong>
          @for (error of customErrors; track $index) {
          {{ error }}.<br>
          }
        </div>
      </div>
    </div>
    }
    @else if (addTimesheetForm.get('consumer')?.value && addTimesheetForm.get('period')?.value) {
    <div class="alert alert-danger"><strong>Error: </strong>{{ getAuthorizationFailureFallbackMessage() }}
    </div>
    }

    @if (showFormFields && consumers?.length < 1 ) { <p>You don't have any active participants.
      </p>
      }
      }
  </form>
</div>

<div class="filter-panel">
  <ng-template #confirmationDialog let-cancel="cancel">
    <p> Are you sure you want to remove this entry ?</p>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #billedUnitsValidationDialog let-cancel="cancel">
    <p>You have entered a shift that is longer than 13 hours and it needs to be verified. If your shift is correct,
      please click “Yes” to submit your shift. If this is not correct, click “Cancel” to modify your time and resubmit your
      shift.</p>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #pendedDialog let-cancel="cancel">
    <ppl-timesheet-staff-errorcode [errorcodeData]="errorcodeData" (onSaveComplete)="onSaveAdjustment($event)"
      [disabled]="true"></ppl-timesheet-staff-errorcode>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #deniedDialog let-cancel="cancel">
    <ppl-timesheet-staff-deniedreasons [deniedData]="deniedData" [disabled]="true"></ppl-timesheet-staff-deniedreasons>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #mealBreakDialog let-confirm="confirm" let-cancel="cancel">
    <p class="meal-break-intro">
      Based on the hours worked, please answer the following meal and rest break questions for each shift below.
    </p>

    <div *ngFor="let mbe of mealBreakEntries; let entryIdx = index" class="meal-break-entry">
      <div class="meal-break-entry__header">
        <span>{{ mbe.serviceDate }}</span>
        <span class="day" *ngIf="mbe.serviceDayName">({{ mbe.serviceDayName }})</span>
        <span class="sep">|</span>
        <span>{{ mbe.serviceTimeInDisplay }} - {{ mbe.serviceTimeOutDisplay }}</span>
      </div>

      <div class="meal-break-entry__body">
        <div class="meal-break-existing-notice alert alert-info"
          *ngIf="mbe.existingMealLines.length > 0 && mbe.mealBreaks.length > 0">
          <strong>Note:</strong> You already added
          {{ mbe.existingMealLines.length > 1 ? 'meal breaks' : 'a meal break' }} as a service line for this date:
          <span *ngFor="let line of mbe.existingMealLines; let last = last">
            {{ line.timeInDisplay }} - {{ line.timeOutDisplay }}<span *ngIf="!last">, </span>
          </span>.
          Any meal break you enter below must not overlap with it.
        </div>

        <div class="meal-break-section" *ngIf="mbe.restBreakNumbers.length > 0">
          <div class="meal-break-row">
            <span class="meal-break-row__label">
              Did you take a 10-minute rest break for every 4 hours worked today?
              <span class="required">*</span>
            </span>
            <div class="meal-break-row__control">
              <nz-radio-group [(ngModel)]="mbe.restBreakTaken" [name]="'rb-' + entryIdx">
                <label nz-radio [nzValue]="true">Yes</label>
                <label nz-radio [nzValue]="false">No</label>
              </nz-radio-group>
            </div>
          </div>
        </div>

        <div class="meal-break-section" *ngIf="mbe.onDutyMeals.length > 0">
          <div *ngFor="let odm of mbe.onDutyMeals" class="meal-break-row">
            <span class="meal-break-row__label">
              Did you take your
              {{ mbe.onDutyMeals.length > 1 ? (odm.number === 1 ? '1st' : '2nd') + ' on-duty meal break' : 'on-duty meal break' }}
              today?
              <span class="required">*</span>
            </span>
            <div class="meal-break-row__control">
              <nz-radio-group [(ngModel)]="odm.taken" [name]="'odm-' + entryIdx + '-' + odm.number">
                <label nz-radio [nzValue]="true">Yes</label>
                <label nz-radio [nzValue]="false">No</label>
              </nz-radio-group>
            </div>
          </div>
        </div>

        <div class="meal-break-section" *ngIf="mbe.mealBreaks.length > 0">
          <div *ngFor="let mb of mbe.mealBreaks">
            <div class="meal-break-row">
              <span class="meal-break-row__label">
                Did you take {{ mbe.mealBreaks.length > 1 ? 'Meal Break ' + mb.number : 'a meal break' }}?
                <span class="required">*</span>
              </span>
              <div class="meal-break-row__control">
                <nz-radio-group [(ngModel)]="mb.taken" [name]="'mb-taken-' + entryIdx + '-' + mb.number"
                  (ngModelChange)="onMealBreakSelectionChange(mb, mbe)">
                  <label nz-radio [nzValue]="true">Yes</label>
                  <label nz-radio [nzValue]="false">No</label>
                </nz-radio-group>
              </div>
            </div>

            <div *ngIf="mb.taken === true" class="meal-break-sub">
              <div class="meal-break-times">
                <div class="meal-break-times__field">
                  <label>Meal Break Start <span class="required">*</span></label>
                  <p-datepicker [(ngModel)]="mb.timeIn" [name]="'mb-in-' + entryIdx + '-' + mb.number"
                    [timeOnly]="true" [hourFormat]="'12'" placeholder="HH:MM AM/PM"
                    appendTo="body"></p-datepicker>
                </div>
                <div class="meal-break-times__field">
                  <label>Meal Break End <span class="required">*</span></label>
                  <p-datepicker [(ngModel)]="mb.timeOut" [name]="'mb-out-' + entryIdx + '-' + mb.number"
                    [timeOnly]="true" [hourFormat]="'12'" placeholder="HH:MM AM/PM"
                    appendTo="body"></p-datepicker>
                </div>
              </div>
            </div>

            <div *ngIf="mb.taken === false && shouldShowWaiver(mb.number, mbe)" class="meal-break-sub">
              <div class="meal-break-row" style="padding: 0;">
                <span class="meal-break-row__label">
                  Did you waive your meal break? <span class="required">*</span>
                </span>
                <div class="meal-break-row__control">
                  <nz-radio-group [(ngModel)]="mb.waived" [name]="'mb-waived-' + entryIdx + '-' + mb.number"
                    (ngModelChange)="onMealBreakWaivedChange(mb, mbe)">
                    <label nz-radio [nzValue]="true">Yes</label>
                    <label nz-radio [nzValue]="false">No</label>
                  </nz-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="meal-break-errors alert alert-danger" *ngIf="mealBreakErrors.length > 0">
      <div *ngFor="let err of mealBreakErrors">{{ err }}</div>
    </div>

    <div class="meal-break-dialog-actions">
      <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
        (click)="cancel()"></ppl-button>
      <ppl-button label="Submit" icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"
        (click)="onMealBreakSubmit(confirm)"></ppl-button>
    </div>
  </ng-template>
</div>